module.exports = __webpack_public_path__ + "img/icon-up-chevron-red.9f8ef378.svg";